import { render, staticRenderFns } from "./detail-managent.vue?vue&type=template&id=10a6de4a&"
import script from "./detail-managent.vue?vue&type=script&lang=js&"
export * from "./detail-managent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports